module.exports = __webpack_public_path__ + "img/log_full.d2d4fdbf.webp";